import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Tabs} from '@components/common/base/tabs'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {
  TwContentWrapper,
  TwTabsWrapper,
  TwTasks
} from '@components/my-tasks/containers'
import {
  MyTasksContext,
  MyTasksStore,
  TabId,
  useMyTasksStore
} from '@components/my-tasks/my-tasks-store'
import {TasksLists} from '@components/my-tasks/tasks-list'
import {TasksListsOld} from '@components/my-tasks/tasks-lists-old'
import {TwPageHeader} from '@components/page/page-component'
import {PredefinedFilter} from '@components/right-panel/search/search-store'
import {SearchTop} from '@components/right-panel/search/search-top'
import {useSyncEvent} from '@containers/hooks'

const TwTitleWrapper = tw.div`
  h-56
  py-12
  flex
  items-center
  gap-16
`

const TwTitle = tw.div`
  text-sm-semibold
  text-panel-text-primary
  flex-none
  flex
  items-center
`

const availablePredefinedFilters: PredefinedFilter[] = [
  'everywhere',
  'task-titles',
  'custom'
]

const Title = ({title}: {title: string}) => (
  <TwTitleWrapper>
    <TwTitle>{title}</TwTitle>
    <SearchTop
      defaultPredefinedFilter="everywhere"
      availablePredefinedFilters={availablePredefinedFilters}
    />
  </TwTitleWrapper>
)

export const MyTasks = () => {
  const [myTasksStore] = useState(() => new MyTasksStore())

  return (
    <MyTasksContext.Provider value={myTasksStore}>
      <MyTasksBase />
    </MyTasksContext.Provider>
  )
}

const MyTasksBase = observer(() => {
  const [state, store] = useMyTasksStore()

  useSyncEvent('current', {filter: '*', debounceTime: 400}, store.syncTabs)

  const onChangeTab = (id: TabId) => {
    store.setCurrentTab(id)
  }

  return (
    <>
      <TwPageHeader>
        <Title title={Lang.msg.taskPage.myTasksPage} />
      </TwPageHeader>
      <TwTasks>
        <TwTabsWrapper>
          <Tabs
            type="default"
            tabs={state.allTabs}
            onChange={onChangeTab}
            defaultActiveId={state.currentTab}
          />
        </TwTabsWrapper>
          {state.currentTab === 'my' && (
            <TwContentWrapper
              style={{
                height: 'calc(100vh - 65px - 56px)'
              }}
            >
              <TasksLists />
            </TwContentWrapper>
          )}
          {state.currentTab !== 'my' && (
            <WithPerfectScrollbar drag>
              <TwContentWrapper
                style={{
                  height: 'calc(100vh - 65px - 56px)'
                }}
              >
                <TasksListsOld
                  currentTab={state.currentTab}
                  getCurrentTasks={store.getCurrentTasks}
                />
              </TwContentWrapper>
            </WithPerfectScrollbar>
          )}
      </TwTasks>
    </>
  )
})
